import { createAsyncThunk } from '@reduxjs/toolkit';
import { PirBoxProductsDetailsMap } from '../../../model/pirbox/pir-box-product-detail';
import { PirBoxProductSummary } from '../../../model/pirbox/pirbox-product-summary';
import pirBoxRepository from '../../../repositories/pirbox/pirbox-repository';
import { AsyncThunkConfig } from '../../async-thunk-config';
import { PirBoxError } from './pir-box-types';
import { YearlyPirIndicatorsBean } from '../../../api/generated/objectway-zenith';

export const retrievePirProductSummary = createAsyncThunk<
  PirBoxProductSummary[],
  string,
  AsyncThunkConfig<PirBoxError>
>('retrieve-pir-product-summary', async (code, thunkApi) => {
  try {
    return await pirBoxRepository.getPirProductSummary(thunkApi, code);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const retrievePirProductDetail = createAsyncThunk<
  PirBoxProductsDetailsMap,
  string,
  AsyncThunkConfig<PirBoxError>
>('retrieve-pir-product-detail', async (code, thunkApi) => {
  try {
    const response = await pirBoxRepository.getPirProductDetail(thunkApi, code);
    return {
      pirCode: code,
      positions: response,
    };
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const getPirProductGraphDetails = createAsyncThunk<
  YearlyPirIndicatorsBean,
  string,
  AsyncThunkConfig<PirBoxError>
>('get-pir-product-graph-details', async (code, thunkApi) => {
  try {
    return await pirBoxRepository.getPirProductGraphDetails(thunkApi, code);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
